import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { hideUpgradeModal } from 'reducers/featureRestrictions/actions';
import { setUserProfile } from 'clevertap/login';
import withFeatureFlags from 'hocs/withFeatureFlags';
import Layout from 'components/Layout';
import UpgradeToMokaposModal from 'components/UpgradeToMokaposModal';
import OutletAssociationModal from 'components/OutletAssociationModal';
import { fetchExperiences, completeExperience } from 'reducers/ftue/actions';
import isExperienceComplete from 'selectors/isExperienceComplete';
import {
  FTUE_SAUDAGAR_ASSOCIATION_POPUP,
  FTUE_ONBOARDING_MERCHANT,
} from 'reducers/ftue/ftueKeys';

class App extends React.Component {
  state = {
    TEMPORARY_STATE_FOR_CMP_MODAL: true,
  };

  componentDidMount() {
    const { loggedIn, user } = this.props.data.moka;

    if (loggedIn) {
      const {
        businessTypesState: businessTypes,
        businessCategoriesAllState: businessCategories,
      } = this.props.data.moka;
      setUserProfile({
        profile: user,
        businessTypes,
        businessCategories,
      });
      this.props.fetchExperiences();
    }
  }

  handleOutletAssociationModalCancel = () => {
    this.props.completeExperience(FTUE_SAUDAGAR_ASSOCIATION_POPUP);
  };

  handleOutletAssociationModalComplete = () => {
    const { redirectTo, completeExperience } = this.props;
    completeExperience(FTUE_SAUDAGAR_ASSOCIATION_POPUP);
    setTimeout(() => redirectTo('/outlets/list'), 1000);
  };

  render() {
    const {
      data,
      location,
      children,
      isShowingUpgradeToMokaposModal,
      hideUpgradeToMokaposModal,
      enableCmpIndicators,
      isShowingOutletAssociationModal,
    } = this.props;
    const { loggedIn, externalRedirectURL } = data.moka;

    // we hide the moka layout if redirect to external url, to prevent showing navbar after the login flow finished
    if (externalRedirectURL) {
      return null;
    }

    const showOutletAssociationModal =
      enableCmpIndicators &&
      isShowingOutletAssociationModal &&
      !isShowingUpgradeToMokaposModal;

    return (
      <div className="full-height">
        <Layout loggedIn={loggedIn} location={location}>
          {children}
        </Layout>
        {isShowingUpgradeToMokaposModal && (
          <UpgradeToMokaposModal
            isShowing
            onOkButtonClick={hideUpgradeToMokaposModal}
          />
        )}
        {showOutletAssociationModal && (
          <OutletAssociationModal
            onComplete={this.handleOutletAssociationModalComplete}
            onCancel={this.handleOutletAssociationModalCancel}
          />
        )}
      </div>
    );
  }
}

App.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
  children: PropTypes.object,
  isShowingUpgradeToMokaposModal: PropTypes.bool,
  hideUpgradeToMokaposModal: PropTypes.func.isRequired,
};

App.defaultProps = {
  isShowingUpgradeToMokaposModal: false,
};

function mapStateToProps(state) {
  const { isShowingUpgradeToMokaposModal } = state.featureRestrictions;
  const { has_saudagar_outlet: hasSaudagarOutlet } = state?.moka?.user;
  const isShowingOutletAssociationModal =
    hasSaudagarOutlet &&
    // Complete Sidebar FTUE first
    isExperienceComplete(state, FTUE_ONBOARDING_MERCHANT) &&
    // Then only show this
    !isExperienceComplete(state, FTUE_SAUDAGAR_ASSOCIATION_POPUP);

  return {
    data: state,
    isShowingUpgradeToMokaposModal,
    isShowingOutletAssociationModal,
  };
}

const mapDispatchToProps = {
  hideUpgradeToMokaposModal: hideUpgradeModal,
  completeExperience,
  fetchExperiences,
  redirectTo: push,
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

function mapFlagsToProps(flags) {
  return {
    enableCmpIndicators: flags.enableCmpIndicators,
  };
}

export default withFeatureFlags(mapFlagsToProps)(connected);
